import { render, staticRenderFns } from "./testemapa2.vue?vue&type=template&id=5285e710"
import script from "./testemapa2.vue?vue&type=script&lang=js"
export * from "./testemapa2.vue?vue&type=script&lang=js"
import style0 from "./testemapa2.vue?vue&type=style&index=0&id=5285e710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports